module.exports = __webpack_public_path__ + "static/media/Impressive Record.6f830404.pdf";